import React from "react";

export default function Title( { title } ) {
  return (
    <h2 className="mb-16 text-center">{ title }</h2>
  )
}